// src/app/components/Discover-Slider/index.tsx
import { SliderItem } from "@/src/lib/types/home";
import ClientDiscoverSlider from "./Discover-Slider/Client";

interface Props {
  data: SliderItem[];
  mainHeading: string;
  ctaText: string;
  sliderTexts?: string[];
}

export default function DiscoverSlider({ data, mainHeading, ctaText, sliderTexts }: Props) {
  return (
    <ClientDiscoverSlider
      data={data}
      mainHeading={mainHeading}
      ctaText={ctaText}
      sliderTexts={sliderTexts}
    />
  );
}
